import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import moment from 'moment';

import './scss/fonts.scss';
import './styles.css';

// Buffer
import { Buffer } from 'buffer'
window.Buffer = Buffer

// Capacitor
import { App as CapacitorApp } from '@capacitor/app';

// Bootstrap 4
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// SweetAlert2
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Mixins
import { tooltipMixin } from './tooltipMixin';
import Tooltip from './components/views/Tooltip.vue';

// Componentes globales Vue 3
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VCalendar from 'v-calendar';
import VueAvatar from 'vue3-avatar';
import { VueImageInput } from 'vue3-picture-input';
import money from 'v-money3';

// jQuery
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// Favicon
import favicon from './assets/icono.png';
const link = document.createElement('link');
link.rel = 'icon';
link.type = 'image/png';
link.href = favicon;
document.head.appendChild(link);

// 🔹 Importar helper de tokens
import { getToken } from './utils/tokenStorage';

import './registerServiceWorker'

// Axios defaults e interceptores
axios.interceptors.request.use(async config => {
    const token = await getToken();
    //console.log('token!!',token);
    config.headers = {
        Authorization: token ? `Bearer ${token}` : '',
        Accept: 'application/json',
    };
    return config;
}, error => Promise.reject(error));

// Variable global para controlar el último 401 mostrado
let last401Time = 0; // timestamp en ms

axios.interceptors.response.use(
    response => response,
    error => {
        const { data, status } = error.response || {};
        const now = Date.now();

        if (data) {
            // Mostrar solo primer error de un 400
            console.log('status: ', status);
            console.log('data: ',data);
            if (typeof data.data === 'object' && data.code === 400) {
                const firstKey = Object.keys(data.data)[0];
                store.dispatch('addToastMessage', {
                    text: data.data[firstKey][0] || `Request error status: ${status}`,
                    type: 'danger'
                });
            } else if (status !== 401) {
                // Otros errores que no sean 401
                store.dispatch('addToastMessage', {
                    text: data.message || `Request error status: ${status}`,
                    type: 'danger'
                });
            }

            // Manejar token expirado / no autorizado
            if (status === 401) {
                // Solo mostrar si no hubo un 401 en los últimos 30 segundos
                if (now - last401Time > 30000) { // 30s = 30000ms
                    last401Time = now; // actualizar el tiempo
                    store.commit('LOGIN_FAIL');
                    if (router.currentRoute.value.path !== '/login' && router.currentRoute.value.path !== '/') {
                        router.push('/');
                    }

                    /*
                    store.dispatch('addToastMessage', {
                        text: 'Su sesión expiró. Por favor, inicie sesión nuevamente.',
                        type: 'danger'
                    });
                    */

                    if (data.message) {
                        store.dispatch('addToastMessage', {
                            text: data.message,
                            type: 'danger'
                        });
                    }
                }
            }
        }

        return Promise.reject(error);
    }
);


// Crear app
const app = createApp(App);

// Ignorar elementos personalizados (ej. Ionic)
app.config.ignoredElements = [/^ion-/];

// Mixins y componentes globales
app.mixin(tooltipMixin);
app.component('Tooltip', Tooltip);
app.component('v-select', vSelect);
app.use(VCalendar, {
  componentPrefix: 'vc',
  screens: {
    sm: '320px',
    md: '768px',
    lg: '1024px',
  },
});
app.component('avatar', VueAvatar);
app.component('picture-change', VueImageInput);
app.use(money, { precision: 4 });

// Plugins
window.Swal = Swal;

// Propiedades globales
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$axios = axios;

// Capacitor back button
CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (!canGoBack || router.currentRoute.value.fullPath === '/') {
        CapacitorApp.exitApp();
    } else {
        window.history.back();
    }
});

// Montar app
app.use(router);
app.use(store);
app.mount('#app');

CapacitorApp.addListener('appUrlOpen', (event) => {
  const slug = event.url.split('.ar').pop();

  if (slug) {
    router.push(slug);
  }
});

// Inicialización de store
store.dispatch('updateStateApkVersion', '2.33');
store.commit('clearConnectedDeviceId');
store.dispatch('initAuth');
if (store.getters.resetAuth) {
    //store.commit('LOGIN_FAIL');
}
